import { Grid, TextField } from "@mui/material";
import { ValidationMessage } from "~/pages/integrations/utils/integrationValidationUtils";
import { Validations } from "~/lib/validations";
import { FieldErrors } from "react-hook-form/dist/types/errors";
import { UseFormRegister } from "react-hook-form";
import { ScopeType } from "~/hooks/useScope";
import { CreateFormInput } from "~/components/FormFields/types";
import { FieldLabel } from "~/components/FormFields/FieldLabel";

interface DisplayNameFieldProps {
  errors: FieldErrors<{ name: string }>;
  register: UseFormRegister<CreateFormInput>;
  disabled?: boolean;
  target: ScopeType;
}

export const DisplayNameField = ({
  errors,
  register,
  disabled = false,
  target,
}: DisplayNameFieldProps) => {
  return (
    <Grid size={{ xs: 12 }} container gap={1}>
      <FieldLabel
        id="display-name-input"
        label="Display name"
        caption={`Define a user-friendly name for this ${target} to use within the UI.`}
      />
      <TextField
        id="display-name-input"
        fullWidth
        placeholder="Display name"
        variant="outlined"
        slotProps={{
          input: {
            sx: { backgroundColor: "code.background" },
          },
        }}
        error={Boolean(errors.name)}
        helperText={
          Boolean(errors.name) && <ValidationMessage error={errors.name} />
        }
        disabled={disabled}
        {...register("name", {
          validate: {
            required: (value) => {
              if (
                value == null ||
                !value.match(Validations.nameInvalidLengthRegex)
              ) {
                return Validations.nameInvalidLengthErrorMsg;
              } else if (!value.match(Validations.nameInvalidCharactersRegex)) {
                return Validations.nameInvalidCharactersErrorMsg;
              }

              return true;
            },
          },
        })}
      />
    </Grid>
  );
};
